import { render, staticRenderFns } from "./offre-abonnement.vue?vue&type=template&id=5c8cb43e&scoped=true"
import script from "./offre-abonnement.vue?vue&type=script&lang=js"
export * from "./offre-abonnement.vue?vue&type=script&lang=js"
import style0 from "./offre-abonnement.vue?vue&type=style&index=0&id=5c8cb43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8cb43e",
  null
  
)

export default component.exports